<div class="documents-page">
  <div class="upload-section">
    <h2>Upload Documents</h2>
    <p>Drag & drop your files or browse to add new documents to the Datahub knowledge base.</p>
    <div>
      <app-upload-zone (fileUploaded)="loadDocument()"></app-upload-zone>
    </div>
  </div>

  <hr class="section-divider" />

  <div class="page-header">
    <div class="header-titles">
      <h2>
        Your Documents
        <i
          class="pi pi-sync"
          (click)="loadDocument()"
          title="Load Document"
          style="cursor: pointer"
          [class.pi-spin]="refreshState"
          [class.text-green-500]="refreshState"
        >
        </i>
      </h2>
      <p>{{ documentsFiltred.length }} documents</p>
    </div>
    <div class="right-header">
      <p-button label="Downalod Documents" class="downlaodButton" (onClick)="downloadDocuments()"></p-button>
      <div class="search-bar">
        <i class="pi pi-search"></i>
        <input type="text" [formControl]="filterSerchBar" placeholder="Search Name,Category or Description..." />
      </div>
    </div>
  </div>

  <div class="documents-container">
    @for (document of documentsFiltred; track document.document_id; let i = $index) {
      @if (document.metadata) {
        <div class="document-card">
          <div class="card-left">
            <div class="title-row">
              <h3 class="document-name" [title]="document.document_id">
                {{ document.document_id }}
              </h3>
              <span class="document-category">{{ document.metadata.category }}</span>
              <p-tag
                [value]="document.status.toLowerCase()"
                [ngStyle]="{ 'background-color': StatusColorMap[document.status] }"
              >
              </p-tag>
              @if (document.metadata.latest === '1') {
                <span class="latest-badge"><span class="dot green"></span> Latest</span>
              }
            </div>

            <p class="description">{{ document.metadata.description }}</p>

            <div class="meta-row">
              <span class="meta-item" title="Year of publication">
                <i class="pi pi-calendar"></i> Year {{ document.metadata.year_of_publication }}
              </span>
              <span class="meta-item" title="Creation date">
                <i class="pi pi-clock"></i> Created {{ document.metadata.timestamp | date: 'MMM d, yyyy, HH:mm' }}
              </span>
              <span class="meta-item" title="Last updated">
                <i class="pi pi-sync"></i> Updated {{ document.updated_at | date: 'MMM d, yyyy, HH:mm' }}
              </span>
            </div>

            <div class="link-row" *ngIf="document.metadata.link">
              <a [href]="document.metadata.link" target="_blank" class="document-link">
                <i class="pi pi-link"></i>
                <span class="link-text" [pTooltip]="document.metadata.link">{{ document.metadata.link }}</span>
                <i class="pi pi-external-link hover-icon"></i>
              </a>
            </div>

            <div class="tags-row">
              @for (tag of document.metadata.keywords; track $index) {
                <span class="tag">#{{ tag }}</span>
              }
            </div>
          </div>

          <div class="card-right actions">
            <p-button
              [disabled]="document.status.toUpperCase() !== 'READY'"
              styleClass="btn-download"
              severity="success"
              icon="pi pi-download"
              label="Download"
              (click)="onDownload(document.document_id)"
            >
            </p-button>
            <p-button
              styleClass="btn-delete"
              [disabled]="document.status.toUpperCase() !== 'READY'"
              severity="danger"
              icon="pi pi-trash"
              label="Delete"
              (click)="onDelete(document.document_id)"
            >
            </p-button>
            <p-button
              styleClass="btn-details"
              [disabled]="document.status.toUpperCase() !== 'READY'"
              icon="pi pi-cog"
              label="Open details"
              (onClick)="openDialog(document)"
            >
            </p-button>
          </div>
        </div>
      } @else {
        <div class="document-card empty-card">
          <div class="card-left">
            <p>
              Missing metadata values on document id : "<strong>{{ document.document_id }}</strong
              >"
            </p>

            <div class="mt-2">
              <p-tag
                [value]="document.status.toLowerCase()"
                [ngStyle]="{ 'background-color': StatusColorMap[document.status] }"
              >
              </p-tag>
            </div>
          </div>

          <div class="card-right actions">
            <p-button
              [disabled]="document.status.toUpperCase() !== 'READY'"
              styleClass="btn-download"
              severity="success"
              icon="pi pi-download"
              label="Download"
              (click)="onDownload(document.document_id)"
            >
            </p-button>
            <p-button
              styleClass="btn-delete"
              [disabled]="document.status.toUpperCase() !== 'READY'"
              severity="danger"
              icon="pi pi-trash"
              label="Delete"
              (click)="onDelete(document.document_id)"
            >
            </p-button>
            <p-button styleClass="btn-details" icon="pi pi-cog" label="Open details" (onClick)="openDialog(document)">
            </p-button>
          </div>
        </div>
      }
    }
  </div>
</div>
<app-upload-dialog-detail [(visible)]="showDialog" [document]="documentSelected!"> </app-upload-dialog-detail>
<p-toast />
<p-confirmdialog />
